<template lang="pug">
div
  b-button.mb-2(v-b-toggle.collapse-service-states variant="outline-primary" size="sm")
    | Mostrar / ocultar tarjetas
  b-collapse#collapse-service-states
    #cardResumenServices
      b-card-group.mb-4(v-if="resumeServicesExists")
        div(v-for="service in this.services" v-if="servicesInProgressExist(service.id)")
          div(v-for="state in service.states")
            div(v-if="state.showResume===true")
              .card
                .header-card
                  font-awesome-icon(:icon="['fas', 'paper-plane']" size="lg" style="color:  #1C3FAA")
                  .title-service {{ service.name }}
                  .percentage(:style=" 'background:' + switchColor(state.order ,service.id)") {{porcentaje(state.order ,service.id)}}%
                h3.progress-service {{ getServicesInProgress(state.order ,service.id) }}/{{ getServiceTotal(service.id) }}
                .state-service {{ service.name }} {{ state.name }}
</template>
<script>
import { mapGetters } from 'vuex'
import state_colors from '../../shared/state_colors'

export default {
  methods: {
    //retorna los servicios con orden igual o mayor al de la tarjeta
    getServicesInProgress(orden ,id){
      let progreso = 0
      this.businessesMonthlyStates.forEach(business => { 
        business.services.forEach(service =>{
          if(service.id === id &&  service.state != null  ){
            if(service.state.order >= orden){
              progreso++
            }
          }
        })
      })
      return progreso
    },
    // Retorna si existe un servicio en el los servicios mensuales
    servicesInProgressExist(serviceId){
      return this.businessesMonthlyStates.find(monthlyStates => monthlyStates.services.find(
        services => services.id === serviceId) !== undefined)
    },
    //retorna la cantidad de empresas que tienen un servicio activo
    getServiceTotal(id){
      let contador=0
      this.businessesMonthlyStates.forEach(business => { 
        business.services.forEach(service =>{
          if(service.id == id &&  service.state != null){
            contador ++
          }
        })
      })
      return contador
    },
    porcentaje(orden, id ){
      let total=0
      if(isNaN((this.getServicesInProgress(orden ,id) * 100 ) / this.getServiceTotal(id))){
        return 0
      }
      total =((this.getServicesInProgress(orden ,id) * 100 ) / this.getServiceTotal(id)).toFixed()
      return total
    },
    switchColor (orden, id) {
      let porcentaje = this.porcentaje(orden, id )
      if(porcentaje==100){
        return state_colors[0].value
      }else if (porcentaje >= 0 && porcentaje <=49){ 
        return state_colors[2].value
      } else return state_colors[1].value
    }
  },
  computed: {
    ...mapGetters(['services']),
    ...mapGetters('MonthlyStates', ['businessesMonthlyStates']),
    resumeServicesExists () {
      for (const service of this.services) {
        for (const state of service.states) {
          if (state.showResume) {
            return true
          }
        }
      }
      return false
    }
  }
}
</script>
<style lang="scss" scoped>
#cardResumenServices{
  .card{
    min-width: 16rem; 
    max-width:16rem;
    margin-right: 20px;
    margin-top: 8px;
    border: transparent;
    border-radius: 5px;
    padding: 14px;
    box-shadow: 0px 3px 6px #00000029;
  }
  .header-card{
    display: flex;
    justify-content: space-between;
    align-items:end;
  }
  .title-service{
    font-weight: bold;
    font-size: 17px;
    line-height: 16px;
    width: 150px;
  }
  .percentage{
//    background: #0CC56A;
    border-radius: 6px;
    padding: 4px 11px;
    font-size: 11px;
    color: white;
    width: 50px;
    text-align: center;
  }
  .progress-service{
    margin-top: 7px;
    font-size: 30px;
    margin-bottom: 2px;
  }
  .state-service{
    color: rgb(184, 184, 184);
    font-size: 12px;
    line-height: 10px;
  }
}

</style>